export default {
  // 导航菜单
  menu: {
    home: '主页',
    campaign: '营销计划',
    report: '数据报告',
    dna: 'DNA',
  },
  
  // 用户菜单
  userMenu: {
    timezone: '时区',
    billingAndPayments: '账单与支付',
    plan: '方案',
    couponCode: '优惠码',
    workspace: '工作空间',
    messages: '消息',
    helpAndFeedback: '帮助与反馈',
    language: '语言',
  },
  
  // 操作按钮
  actions: {
    copyLink: '复制链接',
    invitationCode: '邀请码',
    logIn: '登录',
    startForFree: '立即开始',
  },
  
  // 工具提示
  tooltips: {
    copyLink: '复制链接',
  },
  
  // 消息提示
  messages: {
    copySuccess: '复制成功。',
    copyFail: '复制失败。',
  },
  
  // 状态显示
  status: {
    beta: '测试版',
  }
};
